import { useRouter } from 'next/router';

import { usePayFlowNavigationStore } from './stores/payFlowNavigation.store';
import { usePaymentsFlowStore } from './stores/payFlow.store';
import paymentsConstants from '../../constants/constants';
import { QuantityUnit } from '../../types/payments';
import {
  Subscription,
  SubscriptionType,
} from '@/v2/domains/Subscriptions/types/subscription';

type StartPayFlowParams = {
  subscriptionType: SubscriptionType;
  existingSubscription?: Subscription;
  quantityUnit?: QuantityUnit;
  withCommunity?: boolean;
};

export function usePayFlow() {
  const router = useRouter();
  const {
    reset: resetNavigation,
    setFlow,
    setFlowParams,
  } = usePayFlowNavigationStore();
  const {
    reset: resetFlow,
    setSubscriptionType,
    setExistingSubscription,
    setQuantityUnit,
  } = usePaymentsFlowStore();

  const start = ({
    subscriptionType,
    existingSubscription,
    quantityUnit,
    withCommunity = false,
  }: StartPayFlowParams) => {
    resetNavigation();
    resetFlow();

    setFlowParams({
      [paymentsConstants.flowParams.withCommunity]: withCommunity,
    });

    setSubscriptionType(subscriptionType);
    if (existingSubscription) {
      setExistingSubscription(existingSubscription);
    }

    if (quantityUnit) {
      setQuantityUnit(quantityUnit);
      setFlow(paymentsConstants.flows.pay.withoutRecurrenceSelector);
    } else {
      setFlow(paymentsConstants.flows.pay.withRecurrenceSelector);
    }

    if (router.asPath.includes('/sign-up')) {
      router.push(`/sign-up/buy/${subscriptionType.id}/payment`);
    } else {
      router.push('/settings/manageSubscription/payment');
    }
  };

  const startFromModal = () => {
    resetNavigation();
    setFlow(paymentsConstants.flows.pay.withoutRecurrenceSelector);
    router.push('/settings/manageSubscription/payment');
  };

  return {
    start,
    startFromModal,
  };
}
